import { useEffect, useState, useContext } from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { AuthInfoContext } from "../../context/AuthContext";
import { ReloadContext } from "../../context/ReloadContext";
import { postSearchBaitaiSelect } from "../../api/baitai";
import { BaitaiData, BaitaiDataSet } from "../../types/WebData";

type Props = {
  baitai: BaitaiDataSet | null;
  setBaitai: React.Dispatch<React.SetStateAction<BaitaiDataSet | null>>;
  label?: string;
  disabled?: boolean;
  is_visible?: boolean;
  kanri_only_flg?: boolean;
};

/**
 * 媒体セレクトボックスコンポーネント
 * 管理会社には所属会社が管理してる媒体のみ表示する
 *
 * @param {Props} { baitai, setBaitai, label, disabled = false, is_visible = true }
 * @return {*} 
 */
const BaitaiSelect = ({ baitai, setBaitai, label = "媒体名", disabled = false, is_visible = true, kanri_only_flg }: Props) => {
  const [authInfo] = useContext(AuthInfoContext);
  const reloadContext = useContext(ReloadContext);
  const [baitaiData, setBaitaiData] = useState<BaitaiData>({ data: [] });

  // 初期化処理
  useEffect(() => {
    let isMounted = true;
    const getBaitaiData = async () => {
      const searchParam = { id: baitai?.id, kengen: authInfo.kengen, kaisha_id: authInfo.kaisha_id, is_visible: is_visible, kanri_only_flg: kanri_only_flg ? true : false };
      const result = await postSearchBaitaiSelect(searchParam);
      if (result.isError) {
        return reloadContext?.setSnackbarInfo({
          isOpen: true,
          type: "error",
          message: result.message,
        });
      }
      const blank = { id: 0 } as BaitaiDataSet;
      result.data.unshift(blank);
      setBaitaiData(result);
    };
    if (isMounted) getBaitaiData();
    return () => { isMounted = false };
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    const baitai = baitaiData.data.find(baitai => event.target.value === String(baitai.id))
    if (!baitai) return;
    setBaitai(baitai);
  };

  return (
    <Box sx={{ minWidth: 120 }} mt={1}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label" >{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={(baitai) ? String(baitai.id) : ""}
          label={label}
          onChange={handleChange}
          disabled={disabled}
        >
          {baitaiData.data.map((baitai) => {
            return (
              <MenuItem key={baitai.id} value={String(baitai.id)} sx={{ height: "36px" }}>
                {baitai.baitai_mei}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}

export default BaitaiSelect;